import {
    DesvincularFuncaoGrupoController,
    ListarFuncoesVinculadasPorGrupoController,
    ListarFuncoesNaoVinculadasPorGrupoController,
    VincularFuncoesGrupoController,
} from "../../../../../Controllers/Geral/Grupos/GruposFuncaoController";
import VinculadorSimples from "../../../../../Components/Table/Vinculador";

interface FuncoesProps {
    idGrupo: number;
}

export default function Funcoes(props: FuncoesProps) {
    return (
        <VinculadorSimples
            id={props.idGrupo}
            title="Função por grupo"
            listarVinculados={ListarFuncoesVinculadasPorGrupoController}
            listarNaoVinculados={ListarFuncoesNaoVinculadasPorGrupoController}
            multiplo={{
                desvincular: (funcoes) =>
                    DesvincularFuncaoGrupoController(
                        funcoes.map((funcao) => funcao.ID_GRUPO_FUNCAO ?? 0)
                    ),
                vincular: (idGrupo, funcoes) =>
                    VincularFuncoesGrupoController(
                        funcoes.map((funcao) => ({
                            ID_FUNCAO: funcao.ID_FUNCAO,
                            ID_GRUPO: idGrupo,
                        }))
                    ),
            }}
            tabelaVinculados={{
                text: "Funções Vinculadas",
                dataField: "NM_FUNCAO",
                key: "ID_GRUPO_FUNCAO",
                overlay: "DS_FUNCAO",
            }}
            tabelaDesvinculados={{
                text: "Funções desvinculadas",
                dataField: "NM_FUNCAO",
                key: "ID_FUNCAO",
                overlay: "DS_FUNCAO",
            }}
        />
    );
}
